import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import DataExplorerTabs from "./DataExplorerTabs";
import { tabs } from "./DataExplorerTabs";
import FileExplorer from "./FileExplorer/FileExplorer";
import Page from "../../../components/Page";
import { makeStyles } from "tss-react/mui";
import { useLocation, useHistory } from "react-router-dom";
import { DATA_EXPLORER_URL } from "../../../utils/routes";
import Header from "./Header";
import { usePostHog } from "posthog-js/react";
import { CLICK_TAB_ON_DATA_EXPLORER } from "../../../utils/posthogEvents";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
  },
}));

function DataExplorer() {
  const { classes } = useStyles();
  const [currentTab, setCurrentTab] = useState(tabs[0].value);
  const location = useLocation();
  const history = useHistory();
  const posthog = usePostHog();
  useEffect(() => {
    // Get initial tab from URL query params
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setCurrentTab(tabParam);
    }
  }, []);

  function handleTabChange(event, tab) {
    setCurrentTab(tab);
    // Reset URL parameters when switching tabs
    const searchParams = new URLSearchParams();
    searchParams.set("tab", tab);
    history.replace({
      pathname: DATA_EXPLORER_URL,
      search: searchParams.toString(),
    });
    posthog.capture(CLICK_TAB_ON_DATA_EXPLORER, { tab: tab });
  }

  return (
    <Page title={"Data Explorer"} className={classes.root}>
      <Box
        height={"100%"}
        overflow={"hidden"}
        display={"flex"}
        flexDirection={"column"}>
        <Header />
        <DataExplorerTabs
          currentTab={currentTab}
          onTabChange={handleTabChange}
        />
        {currentTab === tabs[0].value && <FileExplorer />}
      </Box>
    </Page>
  );
}

export default DataExplorer;
